import clsx from 'clsx'

interface Message {
  id: string
  role: 'user' | 'bot' | 'system'
  content: string
}

interface ChatMessageProps {
  message: Message
}

export default function ChatMessage({ message }: ChatMessageProps) {
  const isUser = message.role === 'user'
  const isSystem = message.role === 'system'

  if (isSystem) {
    return (
      <div className="text-center">
        <span className="text-xs text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded-full">
          {message.content}
        </span>
      </div>
    )
  }

  // Parse markdown-like formatting
  const formatContent = (content: string) => {
    return content
      .split('\n')
      .map((line, i) => {
        // Bold text
        let formatted = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        // List items
        if (formatted.startsWith('- ')) {
          formatted = `<span class="block ml-2">• ${formatted.slice(2)}</span>`
        }
        return <span key={i} className="block" dangerouslySetInnerHTML={{ __html: formatted }} />
      })
  }

  return (
    <div className={clsx('flex', isUser ? 'justify-end' : 'justify-start')}>
      <div
        className={clsx(
          'max-w-[80%] px-4 py-2 rounded-2xl',
          isUser
            ? 'bg-primary-600 text-white rounded-br-md'
            : 'bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white rounded-bl-md'
        )}
      >
        <div className="text-sm leading-relaxed">
          {formatContent(message.content)}
        </div>
      </div>
    </div>
  )
}
